import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from './useAuth'
import { useProvider } from './useMoodPlot'

export default function useMoodUser() {
  const { user } = useAuth()
  const { t } = useTranslation()
  const {
    state: { anon, displayName },
  } = useProvider()

  const fullName = user?.user_metadata?.full_name

  const name = useMemo(() => {
    if (displayName) return displayName
    if (anon) return t('basic.anonymous')
    if (fullName) return fullName
    return t('basic.anonymous')
  }, [anon, displayName, fullName, t])

  return { name }
}
